<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h5 class="panel-title">
                <span class="title">Gerencia as configurações de emissão do Contribuinte.</span>
                <br />
                <span class="navigation">Configurações > Contribuinte</span>
              </h5>
            </div>
          </div>
        </div>
        <TabView>
          <TabPanel header="Dados">
            <div class="card-body">
              <div class="row" v-if="this.currentUser.usuario.idBolAdmin">
                <div class="col-md-6 mb-2">
                  <label for="nome">Tipo de Perfil:</label>
                  <span class="p-fluid">
                    <Dropdown id="idTipoPerfil" v-model="selectedTipoPerfil" :options="tiposPerfil" optionLabel="detail"
                      placeholder="Selecione uma opção" />
                  </span>
                </div>
              </div>

              <!--<div class="row" v-if="this.currentUser.usuario.idBolAdmin">
                <div class="col-md-3 mb-2">
                  <label for="nome">Contribuinte sempre Retem na Fonte como Prestador de Serviços?</label>
                  <span class="p-fluid">
                    <Dropdown id="idBolSempreRetem" v-model="selectedSempreRetem" :options="opcoes" optionLabel="name"
                      placeholder="Selecione uma opção" />
                  </span>
                </div>
              </div>-->
              <div class="row" v-if="this.currentUser.usuario.idBolAdmin">
                <div class="col-md-3 mb-2">
                  <label for="selectedTesesEValidacoes">Empresa de testes e validações? (Quando habilitado as notas não sobem para o nacional!)</label>
                  <span class="p-fluid">
                    <Dropdown id="selectedTesesEValidacoes" v-model="selectedTesesEValidacoes" :options="opcoes"
                      optionLabel="name" placeholder="Selecione uma opção" />
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 mb-2">
                  <label for="nome">Bloquear o envio de e-mails de Notas Fiscais/DAPS para Tomadores?</label>
                  <span class="p-fluid">
                    <Dropdown id="selectedNaoEnviarEmails" v-model="selectedNaoEnviarEmails" :options="opcoes"
                      optionLabel="name" placeholder="Selecione uma opção" />
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 mb-2">
                  <label for="nome">Bloquear o recebimento de e-mails como Tomador de Notas Fiscais/DAPS?</label>
                  <Button id="dialofRecebimentoEmailsBloqueados" @click="openDialogBlacklistEmails()"
                  label="Informe aqui seus E-mails para bloqueio" title="Informe aqui seus E-mails para bloqueio" icon="pi pi-plus" />
                  
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mb-2">
                  <label for="emails">E-mail(s) Alternativo(s) - Máximo de três e-mails separados por ponto e virgula
                    (;):</label>
                  <span class="p-fluid">
                    <InputText type="text" id="emails" v-model="confContr.emailsAlternativos" />
                  </span>
                </div>
              </div>
              <div class="row" v-if="observacaoClienteNfse">
                <div class="col-md-6 mb-2">
                  <label for="obs">Observação Padrão: Ao emitir uma nova nota o sistema ira preencher a Observação da Nota
                    automaticamente.</label>
                  <span class="p-fluid">
                    <textarea type="text" id="obs" v-model="confContr.msgObservacaoNota" rows="5" />
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mb-2">
                  <label for="dis">Discriminação Padrão da Nota Fiscal: Ao emitir uma nova nota o sistema ira preencher a
                    Discriminação da Nota automaticamente.</label>
                  <span class="p-fluid">
                    <textarea type="text" id="dis" v-model="confContr.msgDiscriminacaoServico" rows="5" />
                  </span>
                </div>
              </div>
              <hr />
              <template>
                <label>* Após usar o botão gravar abaixo, use o menu do sistema 'Sair' e relogue para o sistema aplicar as
                  alterações realizadas aqui.</label><br />
                <Button @click="onSubmit()" label="Gravar" title="Gravar" type="submit"
                  class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading">
                </Button>
              </template>
            </div>
          </TabPanel>
          <TabPanel header="Logomarca">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-2">
                  <img :src="image" alt="Base64 encoded image" v-show="exibirLogo" />
                  <hr />
                  <input type="file" @change="onFileChanged" accept="image/*" />
                  <hr />
                  <Button @click="onUpload()" label="Upload" type="button" class="p-button-primary mr-2 p-button-success"
                    icon="pi pi-check" :disabled="!this.imageSelect" />
                  <Button @click="removerLogo()" label="Remover" type="button"
                    class="p-button-primary mr-2 p-button-danger" icon="pi pi-check" :disabled="!this.exibirLogo" />
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Dados Cadastrais"
            v-if="isEventual && contribuinteCadastro && contribuinteCadastro.id && contribuinteCadastro.idPessoa">
            <div class="card-body">
              <div class="row">
                <div class="row d-flex align-items-end">
                  <div class="col-md-3 mb-2">
                    <label for="tipoTomador">CPF/CNPJ:</label>
                    <span class="p-fluid">
                      <InputText v-model="contribuinteCadastro.idPessoa.numeroDocumentoJuridico" type="text" disabled />
                    </span>
                  </div>

                  <div class="col-md-6 mb-2">
                    <label for="tipoTomador">Nome:</label>
                    <span class="p-fluid">
                      <InputText v-model="contribuinteCadastro.idPessoa.nomeGeral" type="text" disabled/>
                    </span>
                  </div>

                  <div class="col-md-3 mb-2">
                    <label for="tipoTomador">Inscrição Municipal:</label>
                    <span class="p-fluid">
                      <InputText v-model="contribuinteCadastro.inscricaoMunicipal" type="text" />
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">

                <div class="row d-flex align-items-end">
                  <div class="col-md-3 mb-2">
                    <label for="tipoTomador">CEP:</label>
                    <span class="p-fluid">
                      <div class="p-inputgroup">
                        <InputMask v-model="contribuinteCadastro.cep" mask="99.999-999" placeholder="Pesquisar" />
                      </div>
                    </span>
                  </div>

                  <div class="col-md-3 mb-2">
                    <label for="munic">Município:</label>
                    <span class="p-fluid">
                      <AutoComplete id="munic" v-model="selectedMunicipio" :dropdown="true"
                        :suggestions="filteredLocalidades" @item-select="setLocalidades($event)"
                        @complete="searchLocalidade($event)" field="detail" placeholder="Pesquisar" />
                    </span>
                  </div>

                  <div class="col-md-3 mb-2">
                    <label for="tipoTomador">Estado:</label>
                    <span class="p-fluid">
                      <InputText v-model="nomeEstado" type="text" disabled />
                    </span>
                  </div>

                  <div class="col-md-3 mb-2">
                    <label for="tipoTomador">País:</label>
                    <span class="p-fluid">
                      <InputText v-model="nomePais" type="text" disabled />
                    </span>
                  </div>

                  <div class="col-md-3 mb-2">
                    <label for="tipoTomador">Bairro:</label>
                    <span class="p-fluid">
                      <AutoComplete id="bairr" v-model="selectedBairro" :dropdown="true" :suggestions="filteredBairros"
                        @item-select="setBairro($event)" @complete="searchBairro($event)" field="nomeBairro"
                        placeholder="Pesquisar" />
                    </span>
                  </div>

                  <div class="col-md-5 mb-2">
                    <label for="tipoTomador">Logradouro:</label>
                    <span class="p-fluid">
                      <AutoComplete id="logra" v-model="selectedLogradouro" :dropdown="true" :suggestions="filteredLogras"
                        @item-select="setLogradouro($event)" @complete="searchLogradouro($event)" placeholder="Pesquisar"
                        field="detail">
                        <template #item="slotProps">
                          <div class="p-fluid" style="max-width: 50vw">
                            {{ slotProps.item.detail }}
                          </div>
                        </template>
                      </AutoComplete>
                    </span>
                  </div>


                  <div class="col-md-2 mb-2">
                    <label for="tipoTomador">Número:</label>
                    <span class="p-fluid">
                      <InputText v-model="contribuinteCadastro.numeroLogradouro" type="text" />
                    </span>
                  </div>

                  <div class="col-md-6 mb-2">
                    <label for="tipoTomador">Complemento:</label>
                    <span class="p-fluid">
                      <InputText v-model="contribuinteCadastro.complementoLogradouro" type="text" maxlength="40" />
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">

                <div class="row d-flex align-items-end">
                  <div class="col-md-6 mb-2">
                    <label for="tipoTomador">E-mail:</label>
                    <span class="p-fluid">
                      <InputText v-model="contribuinteCadastro.contatos.email" type="text" />
                    </span>
                  </div>

                  <div class="col-md-3 mb-2">
                    <label for="tipoTomador">Telefone:</label>
                    <span class="p-fluid">
                      <InputMask v-model="contribuinteCadastro.contatos.telefone" mask="(99) 9999-9999" />
                    </span>
                  </div>

                  <div class="col-md-3 mb-2">
                    <label for="tipoTomador">Celular:</label>
                    <span class="p-fluid">
                      <InputMask v-model="contribuinteCadastro.contatos.celular" mask="(99) 99999-999?9" />
                    </span>
                  </div>
                </div>
              </div>
              <hr />
              <template>
                <Button @click="atualizarDadosCadastrais()" label="Atualizar Dados Cadastrais" title="Atualizar Dados Cadastrais" type="button"
                  class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading">
                </Button>
              </template>

            </div>
          </TabPanel>
        </TabView>
      </div>
      <Dialog :visible.sync="showDialogBlacklistEmails" class="modal-interno-custom" :contentStyle="{ overflow: 'visible', width: '150vh', height: '90hv', }" :modal="true">
        <h1 class="titulo-header">
          Adicionar E-mails à Blacklist
          <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
            @click="showDialogBlacklistEmails = false" />
        </h1>
        <div class="scrolable-dialogg">
          <div class="row">
            <div class="col-md-12 mb-2">
              <div class="p-inputgroup">
                <InputText v-model="email" placeholder="Adicionar E-mail" />
                <Button title="Adicionar E-mail" icon="pi pi-plus" @click="adicionarEmail()" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 mb-2">
              <span class="p-fluid">
                <div class="flex align-items-center">
                  <Chip class="mt-2 mr-2 custom-chip" v-for="(email) in listEmailsBlacklistContr" :key="email.id" :label="email.email"
                    @remove="deleteEmailBlacklist(email.id)" removable />
                </div>
              </span>
              <hr />
              <div class="mt-4">
                Os e-mails listados acima não serão notificados ao ser feita uma Emissão de NFSE ou DAPS.
              </div>
              <hr />
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import ContrConfiguracaoService from "../services/nfse/contr.configuracao.service";
import CredenciamentoTipoService from "../services/tributario/credenciamento.tipo.service"
import ContribuinteConfiguracao from "../models/nfse/ContribuinteConfiguracao";
import SolicitacaoCadastroService from "../services/tributario/solicitacao.cadastro.service";
import NotaFiscalService from "../services/nfse/notafiscal.service";

export default {
  name: "configContribuinte",
  data() {
    return {
      loading: false,
      idCliente: null,
      exibirLogo: false,
      selectedFile: null,
      currentUser: null,
      confContr: null,
      image: "",
      imageSelect: false,
      selectedSempreRetem: null,
      selectedNaoReceberEmails: null,
      selectedNaoEnviarEmails: null,
      selectedTesesEValidacoes: null,
      selectedTipoPerfil: null,
      opcoes: [{ name: "Sim", key: "S" }, { name: "Não", key: "N" }],
      tiposPerfil: [],
      observacaoClienteNfse: false,
      isEventual: false,
      contribuinteCadastro: null,
      selectedMunicipio: null,
      filteredLocalidades: null,
      selectedBairro: null,
      filteredBairros: null,
      selectedLogradouro: null,
      filteredLogras: null,
      loadingMensagemAnexo: false,
      showDialogBlacklistEmails: false,
      email: "",
      listaEmail: [],
      listEmailsBlacklistContr: [],
      filtersModel: {
        email: ''
      },
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.idCliente = this.currentUser.usuario.idCliente;
    this.observacaoClienteNfse = this.currentUser.configuracao.idBolObservacaoNfse === "S";
    this.confContr = new ContribuinteConfiguracao();
    this.getTiposPerfil();
  },
  methods: {
    getTiposPerfil() {
      //Busca Tipos do Perfil
      CredenciamentoTipoService.findAllCredenciamentoTipo(this.currentUser.usuario.idCliente).then(
        data => {
          this.tiposPerfil = data.data
          this.getDados();
        }
      )
    },
    async getDados() {
      this.confContr = new ContribuinteConfiguracao();
      this.confContr.idCliente = this.currentUser.usuario.idCliente;
      this.confContr.idUsuario = this.currentUser.usuario.idUsuario;
      this.confContr.idContribuinte = this.currentUser.contribuinte.idContribuinte;

      await this.getContrConfiguacao();
      await this.getContribuinteCadastro();

    },
    async getContrConfiguacao() {
      ContrConfiguracaoService.get(
        this.currentUser.contribuinte.idContribuinte,
        this.currentUser.contribuinte.idUsuario
      ).then(response => {

        console.log(response)

        this.exibirLogo = false;
        this.confContr = response.data;
        if (response.data.logomarca) {
          this.exibirLogo = true;
          this.image = "data:image/jpg;base64,".concat(
            this.image.concat(response.data.logomarca)
          );
        }
        this.selectedSempreRetem = this.opcoes.filter(
          local => local.key == response.data.idBolSempreRetem
        )[0];
        this.selectedNaoReceberEmails = this.opcoes.filter(
          local => local.key == response.data.idBolNaoReceberEmailNfsDaps
        )[0];
        this.selectedNaoEnviarEmails = this.opcoes.filter(
          local => local.key == response.data.idBolNaoEnviarEmailNfsDaps
        )[0];
        this.selectedTesesEValidacoes = this.opcoes.filter(
          local => local.key == response.data.idBolEmpresaTestesValidacoes
        )[0];

        this.selectedTipoPerfil = this.tiposPerfil.filter(
          tipo => tipo.tipo == response.data.credenciamentoTipo
        )[0];
      });
    },
    async getContribuinteCadastro() {
      this.isEventual = false;
      ContrConfiguracaoService.getContribuinteCadastro(
        this.currentUser.contribuinte.idContribuinte
      ).then(response => {

        console.log(response);

        this.contribuinteCadastro = response.data;

        if(this.contribuinteCadastro && this.contribuinteCadastro.idContribuinteTipo && this.contribuinteCadastro.idContribuinteTipo.id === this.currentUser.configuracao.idContrTipoEventual){
          this.isEventual = true;
        }

        this.selectedMunicipio = this.contribuinteCadastro.idLocalidadeMunicipio;
        this.selectedLogradouro = this.contribuinteCadastro.idLogradouro
          ? this.contribuinteCadastro.idLogradouro
          : null;
        this.selectedBairro = this.contribuinteCadastro.idBairro
          ? this.contribuinteCadastro.idBairro
          : null;
      });
    },
    onFileChanged(event) {
      const file = event.target.files[0];
      this.selectedFile = file;
      this.imageSelect = true;
    },
    onUpload() {
      ContrConfiguracaoService.upload(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.selectedFile
      ).then(
        response => {
          console.log(response);
          this.image = "";
          this.getDados();
          this.$root.$emit(
            "alert:success",
            "Logomarca adicionada com sucesso!"
          );
        },
        error => {
          let errorMessage = "Houve um problema ao realizar o Upload!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$root.$emit("alert:error", errorMessage);
        }
      );
    },
    removerLogo() {
      ContrConfiguracaoService.removerLogo(
        this.currentUser.contribuinte.idContribuinte
      ).then(data => {
        console.log(data);
        this.image = "";
        this.exibirLogo = false;
        this.$toast.add({
          severity: "success",
          summary: "Logomarca removida com sucesso!"
        });
      });
    },
    onSubmit() {
      this.loading = true;

      this.salvar();

      this.loading = false;
    },
    atualizarDadosCadastrais(){
      this.loading = true;

      this.contribuinteCadastro.idBairro = this.selectedBairro;
      this.contribuinteCadastro.idLocalidadeMunicipio = this.selectedMunicipio;
      this.contribuinteCadastro.idLogradouro = this.selectedLogradouro;

      ContrConfiguracaoService.atualizarDadosContribuinte(this.contribuinteCadastro).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Dados cadastrais atualizados com sucesso"
          });
        },
        error => {
          let errorMessage = "Houve um problema ao atualizar dados cadastrais!";
          //if (error.response) {
          //  errorMessage = error.response.data;
          //}
          console.log(error)
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );

      this.loading = false;
    },
    salvar() {
      this.confContr.idCliente = this.currentUser.usuario.idCliente;
      this.confContr.idUsuario = this.currentUser.usuario.idUsuario;
      this.confContr.idContribuinte = this.currentUser.contribuinte.idContribuinte;
      this.confContr.credenciamentoTipo = this.selectedTipoPerfil
        ? this.selectedTipoPerfil.tipo
        : null;
      this.confContr.idBolSempreRetem = this.selectedSempreRetem
        ? this.selectedSempreRetem.key
        : null;
      this.confContr.idBolNaoReceberEmailNfsDaps = this.selectedNaoReceberEmails
        ? this.selectedNaoReceberEmails.key
        : null;
      this.confContr.idBolNaoEnviarEmailNfsDaps = this.selectedNaoEnviarEmails
        ? this.selectedNaoEnviarEmails.key
        : null;
      this.confContr.idBolEmpresaTestesValidacoes = this.selectedTesesEValidacoes
        ? this.selectedTesesEValidacoes.key
        : null;

      ContrConfiguracaoService.save(this.confContr, this.currentUser.contribuinte.idUsuario).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Configuracão salva com sucesso"
          });
        },
        error => {
          let errorMessage = "Houve um problema ao salvar a configuracao!";
          //if (error.response) {
          //  errorMessage = error.response.data;
          //}
          console.log(error)
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },
    setLocalidades(event) {
      this.selectedMunicipio = event.value;
    },

    searchLocalidade(event) {
      setTimeout(async () => {
        this.filteredLocalidades =
          await SolicitacaoCadastroService.findAllByFiltro(event.query);
      }, 250);
    },

    setBairro(event) {
      this.processando(true);
      this.selectedBairro = event.value;
      this.processando(false);
    },

    searchBairro(event) {
      setTimeout(async () => {
        this.filteredBairros =
          await SolicitacaoCadastroService.findAllBairroByFiltro(
            this.idCliente,
            event.query
          );
      }, 250);
    },

    setLogradouro(event) {
      this.processando(true);
      this.selectedLogradouro = event.value;
      this.processando(false);
    },

    searchLogradouro(event) {
      setTimeout(async () => {
        this.filteredLogras =
          await SolicitacaoCadastroService.findAllLogradouroByFiltro(
            this.idCliente,
            event.query
          );
      }, 250);
    },

    openDialogBlacklistEmails(){
      this.showDialogBlacklistEmails = true;
      this.pesquisarEmails();
    },

    adicionarEmail() {
      const emailFormatado = this.email.trim();

      if (emailFormatado === "") {
        this.$toast.add({
          severity: "warn",
          summary: "Aviso",
          detail: "Por favor, insira um e-mail!",
          life: 6000
        });
        return;
      }

      if (!emailFormatado.includes("@")) {
        this.$toast.add({
          severity: "warn",
          summary: "Aviso",
          detail: "Por favor, insira um e-mail válido!",
          life: 6000
        });
        return;
      }

      if (this.listaEmail.includes(emailFormatado)) {
        this.$toast.add({
          severity: "warn",
          summary: "Aviso",
          detail: "O e-mail já foi adicionado!",
          life: 6000
        });
        return;
      }

      this.listaEmail = [this.email];
      this.gravarEmail();
      this.email = "";
    },

    removerEmail(index) {
      this.listaEmail.splice(index, 1);
    },

    gravarEmail() {
      if (this.listaEmail.length > 0) {
        NotaFiscalService.saveEmailBlacklistContribuinte(this.listaEmail)
          .then((response) => {
            const { savedEmails, emailsAlreadyExist } = response.data;
            if (savedEmails && savedEmails.length > 0) {
              this.$toast.add({
                severity: "success",
                summary: "E-mails adicionados com sucesso!",
                detail: `E-mails adicionados: ${savedEmails.map(e => e.email).join(", ")}`,
                life: 10000,
              });
              this.pesquisarEmails();
            }
            if (emailsAlreadyExist && emailsAlreadyExist.length > 0) {
              this.$toast.add({
                severity: "warn",
                summary: "Aviso",
                detail: `Os seguintes e-mails já estavam na blacklist: ${emailsAlreadyExist.join(", ")}`,
                life: 10000,
              });
              this.pesquisarEmails();
            }

            this.listaEmail = [];
          })
          .catch((error) => {
            let errorMessage = "Houve um problema ao adicionar os E-mails!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage,
              life: 10000,
            });
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Aviso",
          detail: "Adicione pelo menos um e-mail antes de gravar!",
          life: 10000,
        });
      }
    },
    pesquisarEmails(){
      NotaFiscalService.findAllEmailsBlacklistContr().then(
        response => {
          console.log(response.data);
          this.listEmailsBlacklistContr = response.data;
        },
        error => {
          let errorMessage = "Houve um problema ao buscar os E-mails!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage,
            life: 6000
          });
        }
      )
    },
    deleteEmailBlacklist(idEmailBlacklist){
      NotaFiscalService.deleteEmailBlacklist(idEmailBlacklist).then(
        response => {
          console.log(response.data);
          this.$toast.add({
            severity: "success",
            summary: "E-mail Removido da Blacklist com Sucesso!",
            life: 6000
          });
          this.pesquisarEmails();
        },
        error => {
          let errorMessage = "Houve um problema ao remover o E-mail da Blacklist!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage,
            life: 6000
          });
        }
      )
    }
  },
  computed: {
    nomeEstado() {
      return this.selectedMunicipio && this.selectedMunicipio.estado
        ? this.selectedMunicipio.estado.detail
        : "";
    },

    nomePais() {
      return this.selectedMunicipio &&
        this.selectedMunicipio.estado &&
        this.selectedMunicipio.estado.pais
        ? this.selectedMunicipio.estado.pais.detail
        : "";
    },
  }
};
</script>

<style src="../assets/css/contrConfiguracao.css"></style>
